import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { html, nothing } from "lit";
import { getClasses, getSpacerSize } from "./utils.js";
import "../../atom/Text/index.js";
import "../../atom/Icon/index.js";
import "../../atom/Row/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfCard = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_selected = false;
    this.dsf_size = "medium";
  }
  render() {
    const classes = getClasses(this);
    const icon = this.dsf_icon ? html`<dsf-icon class="h-16 w-16" dsf_name=${this.dsf_icon}></dsf-icon>` : nothing;
    const title = this.dsf_title ? html`<dsf-text dsf_level="s-semibold">${this.dsf_title}</dsf-text>` : nothing;
    const useBuiltin = this.dsf_title || this.dsf_icon;
    const spacerSize = getSpacerSize(this);
    const builtin = html`
      <dsf-row class="items-center" dsf_gap=${spacerSize}> ${icon} ${title} </dsf-row>
      <dsf-spacer dsf_size=${spacerSize}></dsf-spacer>
    `;
    return html`
      <div class="${classes}">
        ${useBuiltin ? builtin : nothing}
        <slot></slot>
      </div>
    `;
  }
};
__decorateClass([
  prop({ type: String })
], DsfCard.prototype, "dsf_icon", 2);
__decorateClass([
  prop({ type: String })
], DsfCard.prototype, "dsf_title", 2);
__decorateClass([
  prop({ type: Boolean })
], DsfCard.prototype, "dsf_selected", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfCard.prototype, "dsf_size", 2);
DsfCard = __decorateClass([
  defineElement("dsf-card")
], DsfCard);
export {
  DsfCard
};
